export default "__VITE_ASSET__50413a57__"